<template>
  <label class="sword-input-label-container-wuk"
    :class="{ 'sword-input-label-placeholder-wuk': labelAsPlaceholder, filled, invalid }"
    @click.capture="() => $emit('click', $event)"
  >
    <p class="sword-input-label-wuk"
       :class="{ disabled }">
      <slot>{{ label }}</slot>
      <span v-if="required"> *</span>
    </p>
    <info-tooltip v-if="infoText">
      <p> {{ $t(infoText) }} </p>
    </info-tooltip>
  </label>
</template>

<script>

import InfoTooltip from '@ui-kit/components/tooltips/InfoTooltip.vue';

export default {
  name: 'InputLabel',
  components: { InfoTooltip },
  emits: ['click'],
  props: {
    label: {
      type: String,
      default: '',
    },
    infoText: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    labelAsPlaceholder: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style lang="scss" scoped>
  .sword-input-label-container-wuk {
    display: flex;

    &:not(.sword-input-label-placeholder-wuk) {
      .sword-input-label-wuk {
        font-weight: $label-font-weight;
      }
    }
    .sword-input-label-wuk {
      color: $context-color-2;
      font-size: $input-label-font-size-wuk;
      line-height: 1.375rem;
      margin-bottom: 1rem;
      flex: 1;
      &.disabled {
        color: $disabled-label-color-wuk;
        cursor: not-allowed;
      }
    }
  }
</style>
